import { ReviewsUS } from '../../../data/pages/home/reviews';
import { useReviewsSectionStyles } from '../../../css/organisms/reviews-section.styles';
import { Route } from '../../../enums';
import { useRouter } from 'next/router';

export const ReviewsSectionOrganism = () => {
  const router = useRouter();
  const classes = useReviewsSectionStyles();

  const bannerActive = true;

  return (
    <div data-cy="reviews-section" className="box-border">
      <div
        className={`md:flex flex-row justify-around items-center max-w-screen-xl mx-auto ${
          bannerActive
            ? 'home-hero-padding-top-banner'
            : 'home-hero-padding-top'
        }`}
      >
        <div className="flex flex-col justify-between">
          <div className="block mx-10">
            <h3 className="text-4xl underline">{ReviewsUS.TITLE}</h3>
          </div>
        </div>
        <div className="flex flex-col">
          <div className={`mx-auto mt-2.5 ${classes.bgImageStyles}`}></div>
        </div>
      </div>
      <div className="-mt-24 box-border">
        <div className="pt-36 flex flex-col items-center relative -mb-48 block justify-around max-w-screen-xl mx-auto pb-20 bg-waldo-blue text-white box-border">
          <div className="md:flex flex-row justify-between mt-10 md:mt-0 md:space-x-12">
            {ReviewsUS.REVIEW.map((review, index) => (
              <div
                className="max-w-xs flex justify-around items-baseline flex-col text-center box-border"
                key={index}
              >
                <img
                  src={`images/icons/${review.image}`}
                  alt={review.alt}
                  className="block mt-2.5 h-5 mx-auto"
                />
                <p className="mt-14 text-2xl mb-8 text-white">
                  {review.paragraph}
                </p>
                <p className="text-lg mx-auto text-white">
                  {review.reviewerName}
                </p>
              </div>
            ))}
          </div>
          <a
            className="btn-secondary-cta block w-80 md:w-[203px] text-base font-waldo-header button mt-5"
            onClick={() => router.push(Route.GET_STARTED)}
          >
            See more
          </a>
        </div>
      </div>
      <div className="bg-waldo-sands pt-24 pb-20 md:pt-32 md:pb-20">
        <div className="max-w-screen-xl md:flex mx-auto w-10/12 justify-around pt-24 box-border md:w-full md:justify-between">
          {ReviewsUS.BUSINESS_REVIEW.map((review, index) => (
            <div
              className="flex justify-between flex-col mx-auto text-center space-y-4 max-w-sm md:px-8 md:justify-start"
              key={index}
            >
              <img
                src={`images/home/press/${review.image}`}
                alt={review.alt}
                className="mb-2.5 mt-8 mx-auto w-24"
              />
              <p className="text-lg">{review.businessParagraph}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
